import { handleActions } from 'redux-actions'

import * as actions from '../../actions'

const defaultState = false

export default handleActions(
  {
    [actions.openEditUniqueAiObjectConnectionsDialog](state, action) {
      return true
    },
    [actions.closeEditUniqueAiObjectConnectionsDialog](state, action) {
      return defaultState
    },
  },
  defaultState
)
